import { Checkbox, Datetime, Field, renderRelatedFields, Select } from "components/shared/form";
import TypeOptions from "components/shared/typeOptions";
import { bidPointTypesEnum, entityTypesEnum, simplifiedTypeCodesEnum } from "helpers/enums";
import React, { Component, Fragment } from "react";
import ExtendedProperties from "./extendedProperties";

export default class GroupComponent extends Component {
    removeItem = (index) => {
        const { items, onChange, entity } = this.props;
        const nextItems = items.filter((_item, i) => index !== i).map((item, i) => ({ ...item, order: i }));
        onChange({ name: entity, value: nextItems });
    };

    reorderItems = (fromIn, toIn) => {
        const { items, onChange, entity } = this.props;
        const item = items[fromIn];
        items.splice(fromIn, 1);
        items.splice(toIn, 0, item);
        onChange({ name: entity, value: items.map((item, order) => ({ ...item, order })) });
    };

    setValue = ({ name, value }, index) => {
        const { items, onChange, entity } = this.props;
        const newItems = items.map((item, i) => (index === i ? { ...item, [name]: value } : item));
        onChange({ name: entity, value: newItems });
    };

    renderField = (props, i) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const { items } = this.props;
        return (
            <Field
                key={props.label}
                wrapper="book-field"
                onChange={(data) => this.setValue(data, i)}
                value={items[i][props.inputProps.name]}
                {...props}
            />
        );
    };

    renderDateField = (props, i) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const { items } = this.props;
        return (
            <Datetime
                key={props.label}
                onChange={(data) => this.setValue(data, i)}
                value={items[i][props.inputProps.name]}
                {...props}
            />
        );
    };

    renderCheckbox = (props, i) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const { items } = this.props;
        return (
            <Checkbox
                key={props.label}
                wrapper="book-field"
                onChange={(data) => this.setValue(data, i)}
                value={items[i][props.inputProps.name]}
                {...props}
            />
        );
    };

    renderSelect = (props, i) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const defProps = {
            key: props.label,
            wrapper: "book-field",
            onChange: (data) => this.setValue(data, i),
            value: this.props.items[i][props.inputProps.name],
        };
        props.dictionary && (props.options = this.props.enums[props.dictionary] || []);
        if (props.relatedFields) {
            const fieldsData = {
                defProps,
                props,
                renderSelect: (data) => this.renderSelect(data, i),
                renderField: (data) => this.renderField(data, i),
            };
            return renderRelatedFields(fieldsData);
        }
        const { key, ...selectProps } = { ...defProps, ...props };
        return <Select {...selectProps} key={key} />;
    };

    setExtendedValue = ({ name, value }, index) => {
        const { items, onChange, entity } = this.props;
        const newItems = items.map((item, i) =>
            index === i ? { ...item, extendedProperties: { ...item.extendedProperties, [name]: value } } : item,
        );
        onChange({ name: entity, value: newItems });
    };

    renderExtendedField = (item, i, options = {}) => {
        let value = this.props.items[i].extendedProperties[item.inputProps.name];
        if (simplifiedTypeCodesEnum.Boolean !== item.typeCode && !value) {
            value = "";
        }
        const props = {
            ...item,
            onChange: (data) => this.setExtendedValue(data, i),
            value,
            ...options,
        };
        switch (item.typeCode) {
            case simplifiedTypeCodesEnum.DateTime:
            case simplifiedTypeCodesEnum.DateTimeWithoutTimezone:
                return this.renderDateField(props, i);
            case simplifiedTypeCodesEnum.Boolean:
                return this.renderCheckbox(props, i);
            default:
                return this.renderField(props, i);
        }
    };

    render() {
        const {
            items,
            Element,
            cargoOwnerProps,
            config,
            entity,
            isEmptyMileageBid,
            enums,
            entityOptions,
            dictionaries,
            customFieldsEnabled,
            hideElement,
        } = this.props;
        return items.map((item, i) => {
            const local = {
                item,
                i,
                renderField: (item) => this.renderField(item, i),
                renderSelect: (item) => this.renderSelect(item, i),
                renderDateField: (item) => this.renderDateField(item, i),
                remove: this.removeItem,
                reorder: this.reorderItems,
                onChange: this.setValue,
                isFirstOrLastItem: i === 0 || i === items.length - 1,
                cargoOwnerProps,
            };
            const key = entity === "bidPoints" ? `${i}_${item.type}_${item.order}` : i;
            const typeOptionsProps = {
                entityOptions,
                enums,
                dictionaries,
                setValue: (data) => this.setValue(data, i),
                entityType: entity === "cargos" ? entityTypesEnum.Cargo : entityTypesEnum.BidPoint,
                typeOptionsValue: item.typeOptions || [],
                isEmptyMileageBid,
                showAllInEmptyMileageBid: customFieldsEnabled,
                modal: this.props.modal,
                roles: this.props.roles,
                canEditBooks: this.props.canEditBooks,
            };
            return (
                <Fragment key={key}>
                    {!hideElement && <Element {...this.props} {...local} />}
                    {entity !== "expenses" && (
                        <div className="d-flex flex-column">
                            {item.type !== bidPointTypesEnum.ServicePoint && (
                                <ExtendedProperties
                                    renderExtendedField={(property) => this.renderExtendedField(property, i)}
                                    config={config.extendedProperties ? config.extendedProperties.config : {}}
                                    isEmptyMileageBid={isEmptyMileageBid}
                                    showAllInEmptyMileageBid={customFieldsEnabled}
                                />
                            )}
                            {item.type !== bidPointTypesEnum.ServicePoint && <TypeOptions {...typeOptionsProps} />}
                        </div>
                    )}
                </Fragment>
            );
        });
    }
}
